/**
 * parseSSEStream — reads a Server-Sent Events `ReadableStream` and fires
 * `onEvent` for every `data:` line, parsed as JSON.
 *
 * Canonical copy lives at src/shared/utils/parseSSEStream.ts.
 * This copy exists because packages/ui-kit cannot import from the app src tree.
 */
export async function parseSSEStream<T>(
  body: ReadableStream<Uint8Array>,
  onEvent: (event: T) => void,
): Promise<void> {
  const reader  = body.getReader();
  const decoder = new TextDecoder();
  let buffer    = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";
    for (const line of lines) {
      if (!line.startsWith("data:")) continue;
      const data = line.slice(5).trim();
      if (!data) continue;
      try { onEvent(JSON.parse(data) as T); } catch { /* skip malformed */ }
    }
  }
}
